var _rect, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLyft({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "#EA0B8C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 32.7679H28.415V58.1036C28.415 62.113 30.2441 64.5014 31.6905 65.5252C30.1593 66.8901 25.4799 68.0844 21.9918 65.1838C19.9352 63.4741 19 60.6628 19 58.0181V32.7679ZM77.8401 53.8136V51.1511H80.7115V41.8103H77.5582C76.3476 36.2023 71.3683 32 65.4132 32C58.5531 32 52.9921 37.5763 52.9921 44.4546V66.2682C54.9465 66.5437 57.2749 66.234 59.2559 64.5868C61.3121 62.8768 62.2473 60.0658 62.2473 57.4211V56.6175H66.9495V47.2767H62.2473V44.4546H62.2586C62.2586 42.7079 63.6709 41.2918 65.4132 41.2918C67.1553 41.2918 68.5732 42.7079 68.5732 44.4546V53.8136C68.5732 60.692 74.1401 66.2682 81 66.2682V56.9764C79.2579 56.9764 77.8401 55.5604 77.8401 53.8136ZM42.182 41.8103V55.5189C42.182 56.2971 41.5381 56.9281 40.7435 56.9281C39.9489 56.9281 39.3049 56.2971 39.3049 55.5189V41.8103H29.9889V57.933C29.9889 60.8333 30.9698 64.5014 35.434 65.6957C39.9028 66.8913 42.4952 64.4163 42.4952 64.4163C42.2591 66.0468 40.7275 67.2412 38.2604 67.4971C36.3937 67.6906 34.0064 67.0707 32.8156 66.5587V75.1006C35.8499 75.9978 39.0594 76.2877 42.2002 75.6766C47.9003 74.5677 51.4978 69.7906 51.4978 63.4352V41.8103H42.182Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLyft);
export default __webpack_public_path__ + "static/media/Lyft.f152bcfc9f32692f235169b42c2201a3.svg";
export { ForwardRef as ReactComponent };